
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#28B764","d":"M4.709 6.59L4.51 9.384c.284 0 .407-.122.555-.269l1.331-1.272 2.76 2.02c.505.282.862.134.998-.465L11.965.91c.161-.749-.27-1.041-.763-.858L.557 4.13c-.726.282-.715.687-.123.87l2.721.847L9.477 1.89c.297-.197.568-.088.345.11L4.71 6.59z"}})])
          )
        }
      }
    